import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { PrivacyPolicyService } from 'src/app/services/privacy-policy.service';
import * as Constants from '../../../models/Constants';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  /** Language form — only the language radio is reactive; delivery uses ngModel like clearFraud */
  languageForm!: FormGroup;

  readonly emailPattern = Constants.PATTERNS.EMAIL;
  public privacyPolicyInfoBanner: string = Constants.PRIVACY_POLICY_INFO_BANNER;
  public privacyPolicySendSuccess: string = Constants.PRIVACY_POLICY_SEND_SUCCESS;
  public privacyPolicySendFailure: string = Constants.PRIVACY_POLICY_SEND_FAILURE;

  readonly customMobileOption = { phoneNumber: '', name: 'mobileNumber', type: 'custom' };
  readonly customEmailOption  = { emailAdress: '',  name: 'email',         type: 'custom' };

  @Output() goToCustomerOverviewEmitter = new EventEmitter<void>();

  languages: { label: string; value: string }[] = [{ label: 'English', value: 'en-US' }];

  constructor(
    public rootScope: RootScopeService,
    private privacyPolicyService: PrivacyPolicyService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.languageForm = this.fb.group({
      language: [{ value: '', disabled: true }, Validators.required]
    });
    this.privacyPolicyService.loadDeliveryOptions();
    this.languages = this.privacyPolicyService.loadLanguages();
  }

  get policyData() {
    return this.rootScope.activeCustTab.privacyPolicyData;
  }

  // ─── Delivery method selection (mirrors fraudStep2RadioSelection) ────────────

  onDeliveryMethodChange(value: any): void {
    this.privacyPolicyService.onDeliveryMethodChange(value, () => this.refreshLanguageSectionState());
  }

  onCustomMobileRadioClick(event: MouseEvent): void {
    const d = this.policyData;
    // preventDefault stops the browser from activating the label→radio link when the tel input is disabled
    if ((d.isEmailSelected || d.isCustomEmailSelected || d.customEmail.length > 0) &&
        (event.target as HTMLElement).tagName.toLowerCase() === 'f-intl-tel-input') {
      event.preventDefault();
    }
  }

  onCustomMobileFocus(): void {
    this.privacyPolicyService.onCustomMobileFocus(this.customMobileOption, () => this.refreshLanguageSectionState());
  }

  onCustomEmailFocus(): void {
    this.privacyPolicyService.onCustomEmailFocus(this.customEmailOption, () => this.refreshLanguageSectionState());
  }

  onTelInputChange(event: any): void {
    this.privacyPolicyService.onTelInputChange(event, () => this.refreshLanguageSectionState());
  }

  onCustomEmailInput(): void {
    this.refreshLanguageSectionState();
  }

  // ─── Language section ────────────────────────────────────────────────────────

  private refreshLanguageSectionState(): void {
    const langCtrl = this.languageForm.get('language')!;
    if (this.privacyPolicyService.isDeliverySelected()) {
      langCtrl.enable();
    } else {
      langCtrl.disable();
      langCtrl.reset('');
    }
  }

  // ─── Send ───────────────────────────────────────────────────────────

  isSendEnabled(): boolean {
    return (
      !this.policyData.isSending &&
      this.privacyPolicyService.isDeliveryValid() &&
      !!this.languageForm.get('language')?.value
    );
  }

  sendPcsNotification(): void {
    if (!this.isSendEnabled()) return;
    this.privacyPolicyService.sendPcsNotification(
      this.languageForm.get('language')?.value,
      () => { this.resetForm(); this.goToCustomerOverviewEmitter.emit(); }
    );
  }

  retrySend(): void {
    this.sendPcsNotification();
  }

  private resetForm(): void {
    this.languageForm.get('language')!.disable();
    this.languageForm.get('language')!.reset('');
  }
}
